module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f14af652813faa3ac863c23fe6418b12.png";